import type { SVGProps } from "react";

/**
 * Timer — classic mechanical kitchen timer with dial.
 */
export function TimerIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {/* Timer body */}
      <circle cx={24} cy={25} r={18} fill="currentColor" opacity={0.08} />
      <circle
        cx={24}
        cy={25}
        r={18}
        stroke="currentColor"
        strokeWidth={1.5}
        opacity={0.35}
        fill="none"
      />
      {/* Base stand */}
      <rect
        x={18}
        y={40}
        width={12}
        height={4}
        rx={1}
        fill="currentColor"
        opacity={0.4}
      />
      {/* Dial markings */}
      <line
        x1={24}
        y1={9}
        x2={24}
        y2={13}
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        opacity={0.4}
      />
      <line
        x1={24}
        y1={37}
        x2={24}
        y2={41}
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        opacity={0.2}
      />
      <line
        x1={8}
        y1={25}
        x2={12}
        y2={25}
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        opacity={0.2}
      />
      <line
        x1={36}
        y1={25}
        x2={40}
        y2={25}
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        opacity={0.4}
      />
      {/* Minute hand */}
      <line
        x1={24}
        y1={25}
        x2={34}
        y2={17}
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        opacity={0.7}
      />
      {/* Center dot */}
      <circle cx={24} cy={25} r={2.5} fill="currentColor" opacity={0.6} />
      {/* Top knob */}
      <rect
        x={21}
        y={4}
        width={6}
        height={4}
        rx={1.5}
        fill="currentColor"
        opacity={0.5}
      />
    </svg>
  );
}
